import { type MouseEvent, useCallback } from "react";

import { type PageTarget, parsePageTag } from "./page_tag";

// Page tags live in server HTML, so one click handler on the thread routes
// them: a click on `a.pt` opens its page instead of following the hash.
export const usePageTagClicks = (onOpenPage: (target: PageTarget) => void) =>
  useCallback(
    (event: MouseEvent<HTMLElement>) => {
      if (!(event.target instanceof Element)) return;

      const tag = event.target.closest("a.pt");
      const target = tag && parsePageTag(tag.getAttribute("href") ?? "");
      if (!target) return;

      event.preventDefault();
      onOpenPage(target);
    },
    [onOpenPage],
  );
